// BSV CHANGES
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface Employee {
  id: number;
  employeeCode: string;
  name: string;
  department: string;
  designation: string;
  mappedDivision: string[]; 
  isActive: boolean;
  startDate?: string;
  endDate?: string;
};

interface jfwState {
  loading: boolean;
  data: Employee[];
  error: string | null;
}

const initialState: jfwState = {
  loading: false,
  data: [],
  error: null,
};


const jfwSlice = createSlice({
  name: 'jfw',
  initialState,
  reducers: {
    getJfwRequest: (state, _action: PayloadAction<{ searchText?: string }>) => {
      state.loading = true;
      state.error = null;
    },
    getJfwSuccess: (state, action: PayloadAction<Employee[]>) => {
      state.loading = false;
      state.data = action.payload;
    },
    getJfwFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    postJfwRequest: (
      state,
      _action: PayloadAction<{
        name: string;
        employeeCode: string;
        designation: string;
        department: string;
        divisionIds: string[];
      }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    
    postJfwSuccess: (state) => {
      state.loading = false;
    },
    postJfwFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    deleteJfwRequest: (state, _action: PayloadAction<{ id: number, endDate: string }>) => {
      state.loading = true;
    },
    deleteJfwSuccess: (state) => {
      state.loading = false;
    },
    deleteJfwFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const jfwReducer = jfwSlice.reducer;
export const {
  getJfwRequest,
  getJfwSuccess,
  getJfwFailure,
  postJfwRequest,
  postJfwSuccess,
  postJfwFailure,
  deleteJfwRequest,
  deleteJfwSuccess,
  deleteJfwFailure,
} = jfwSlice.actions;